import { render, staticRenderFns } from "./GeneralLedgerAccount.vue?vue&type=template&id=d13216b2&"
import script from "./GeneralLedgerAccount.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports